import { Component, Input } from '@angular/core';
import { BaseDataElement } from '../../../core/elements/models/base-data-element.model';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'acr-hint-diagram',
  template: `<ng-container *ngIf="dataElement !== undefined">
  <button type="button" class="btn btn-default btn-xs" data-toggle="modal" attr.data-target="#{{'diag_'+dataElement.id}}"
    (click)="resetCarouselIndex()">
    <span class="glyphicon glyphicon-picture" aria-hidden="true" data-toggle="tooltip" data-placement="right" title="Hint Diagrams"></span>
  </button>
  <div class="modal inmodal fade" id="{{'diag_'+dataElement.id}}" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">
            <span aria-hidden="true">&times;</span>
            <span class="sr-only">Close</span>
          </button>
          <h4 class="modal-title float-left">{{dataElement.label}}</h4>
        </div>
        <div class="modal-body">
          <ng-container>
            <carousel [(activeSlide)]="activeSlideIndex" interval="false">
              <ng-container *ngFor="let diag of dataElement.diagrams ">
                <slide>
                    <img class="img-responsive max-w-h-100" [src]="domSanitizer.bypassSecurityTrustUrl(getImageDataUrl(diag.location))" alt="{{ diag.label }}">
                </slide>
              </ng-container>
            </carousel>
          </ng-container>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</ng-container>
`,
  styles: [``, `.required-field{color:red}.padding-l-5{padding-left:5px}.whitespace{margin-left:5px}.max-w-h-100{max-width:100%;max-height:100%}.carousel-control>.fa{font-size:40px;position:absolute;top:50%;z-index:5;display:inline-block;margin-top:-20px}.carousel-control.left{background-repeat:repeat-x}.carousel-control.left,.carousel-control.right{background-image:none}.carousel-control.right{background-image:linear-gradient(to right,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5) 100%);background-repeat:repeat-x}.scroll{overflow-y:scroll;overflow-x:hidden}.div-simulator-form-height{height:calc(100vh - 100px);overflow-y:scroll;overflow-x:hidden}.div-report-text-scroll{overflow-x:hidden;overflow-y:auto;max-height:calc(100vh - 300px)}.padding-r-10{padding-right:10px}.slide-left{left:30px}.slide-right{right:30px}hr{margin-top:10px;margin-bottom:10px}.white-space-line{white-space:pre-line;word-wrap:break-word}p{margin:0 0 10px}.form-control{border-radius:0;box-shadow:none;border-color:#d2d6de}h4.modal-title.float-left{float:left}.margin-b-0{margin-bottom:0}.font-weight-400{font-weight:400}.custom-radio-style{float:left;margin-right:15px}.zoom{width:100%;overflow:auto}.zoom img{height:auto;width:100%;min-width:100%;max-width:inherit!important}.btn-zoom{background-color:#f4f4f4;color:#444;border-color:#ddd}.btn-zoom.hover,.btn-zoom:active,.btn-zoom:hover{background-color:#e7e7e7}@media (min-width:768px){label.control-label{padding-left:20px}}.padding-5{padding:5px}`]
})
export class HintDiagramComponent {
  @Input() dataElement: BaseDataElement;
  @Input() imagePath: string;
  isDataURL = /^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+\=[a-z\-]+)?)?(;base64)?,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i;
  activeSlideIndex = 0;
  domSanitizer: DomSanitizer;

  constructor(domSanitizer: DomSanitizer) {
    this.domSanitizer = domSanitizer;
  }

  resetCarouselIndex() {
    this.activeSlideIndex = 0;
  }

  getImageDataUrl(location: string): string {
    const isDataURL = !!location.match(this.isDataURL);
    if (isDataURL) {
      location = location.replace('unsafe:', '');
      return location;
    } else {
      return this.imagePath + '/' + location;
    }
  }
}
